import { Star } from 'lucide-react';

type RatingProps = {
  rating: number;
  numberOfRatings: number;
};

const RATING_THRESHOLD = 10;

export const Rating = ({ rating, numberOfRatings }: RatingProps): React.ReactElement | null => {
  if (numberOfRatings < RATING_THRESHOLD) {
    return null;
  }
  const total = `(${numberOfRatings})`;
  return (
    <div className="flex gap-1 items-center">
      <Star className="size-3 fill-teal-600 text-teal-600" />
      <span className="text-xs font-semibold text-denim-800">{rating.toFixed(2)}</span>
      <span className="text-xs text-gray-400">{total}</span>
    </div>
  );
};
